<h2 mat-dialog-title class="rec-title">
  <mat-icon>local_shipping</mat-icon>
  Recepción de delivery — {{ warehouseName }}
</h2>

<mat-dialog-content>
  <p class="hint">La entrada registra <b>piezas</b>. Las piezas entran al locker cuando se asocian a su etiqueta RFID (acción <b>RFID</b> en la bitácora).</p>

  <div class="grid">
    <mat-form-field><mat-label>No. de delivery / nota de despacho</mat-label>
      <input matInput [(ngModel)]="deliveryFolio">
    </mat-form-field>
    <mat-form-field><mat-label>Nombre completo del operador{{ isOther ? ' (opcional)' : '' }}</mat-label>
      <input matInput [(ngModel)]="carrierName" autocomplete="off" placeholder="Nombre y apellidos de quien entrega">
      <mat-icon matSuffix>badge</mat-icon>
      @if (!isOther && carrierName && !operatorOk) {<mat-hint class="warn">Escribe nombre y apellido</mat-hint>}
    </mat-form-field>
    <mat-form-field><mat-label>Solicitud de material que surte (opcional)</mat-label>
      <mat-select [(ngModel)]="materialRequest">
        <mat-option [value]="null">— Sin solicitud —</mat-option>
        @for (r of requestOptions; track r.id) { <mat-option [value]="r.id">{{ requestLabel(r) }}</mat-option> }
      </mat-select>
      <mat-hint>Al aceptar, la solicitud queda Recibida</mat-hint>
    </mat-form-field>
  </div>

  <div class="checks">
    <mat-slide-toggle [(ngModel)]="arrivedAsStated">¿Llegó tal cual lo que dice el DLV (cantidades y lotes)?</mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="exclusiveDelivery">¿El transportista te entregó solo a ti?</mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="isOther">Es una entrada de otro origen (no es delivery normal)</mat-slide-toggle>
  </div>
  @if (isOther) {
    <mat-form-field class="wide"><mat-label>Razón de la entrada / de dónde se mandó el material</mat-label>
      <input matInput [(ngModel)]="origin">
    </mat-form-field>
  }

  <div class="add-row">
    <mat-form-field class="add-row__search">
      <mat-label>Buscar insumo (código o descripción)</mat-label>
      <input matInput [(ngModel)]="productFilter">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <input #photoInput type="file" accept="image/*" capture="environment" hidden (change)="fromPhoto($event)">
    <button mat-stroked-button type="button" (click)="photoInput.click()" [disabled]="ocrRunning"
            matTooltip="Toma o sube una foto de la tabla del documento de entrega">
      <mat-icon>photo_camera</mat-icon> Desde foto
    </button>
  </div>
  @if (ocrRunning) {
    <div class="ocr-progress">
      <mat-progress-bar mode="determinate" [value]="ocrProgress"></mat-progress-bar>
      <span>Leyendo la foto… {{ ocrProgress }}%</span>
    </div>
  }
  @if (productFilter.trim()) {
    <div class="results">
      @for (prod of filteredProducts; track prod.id) {
        <button mat-menu-item (click)="addRow(prod)"><b>{{ prod.code }}</b>&nbsp;{{ prod.description }}</button>
      }
    </div>
  }

  <table class="rows">
    <tr><th>Código</th><th>Descripción</th><th>Lote</th><th>Caducidad</th><th class="num">Piezas</th><th></th></tr>
    @for (row of rows; track $index) {
      <tr>
        <td>{{ row.code }} @if (row.fromPhoto) {<mat-icon class="from-photo" matTooltip="Leído de la foto: revisa">photo_camera</mat-icon>}</td>
        <td>{{ row.description }}</td>
        <td><input class="cell" [(ngModel)]="row.batch" placeholder="S/L"></td>
        <td><input class="cell" type="date" [(ngModel)]="row.expiration"></td>
        <td class="num">
          <span class="qty">
            <button type="button" class="qty__btn" (click)="step(row, -1)" [disabled]="row.quantity <= 1" aria-label="Una pieza menos">−</button>
            <input class="cell cell--num" type="number" min="1" step="1" [(ngModel)]="row.quantity" (blur)="fixQty(row)" (change)="fixQty(row)" aria-label="Piezas">
            <button type="button" class="qty__btn" (click)="step(row, 1)" aria-label="Una pieza más">+</button>
          </span>
        </td>
        <td><button mat-icon-button color="warn" (click)="removeRow($index)"><mat-icon>close</mat-icon></button></td>
      </tr>
    }
  </table>
  @if (rows.length === 0) { <p class="empty">Sin renglones. Busca un insumo y agrégalo.</p> }
  <p class="count"><b>{{ totalPieces }}</b> piezas en total</p>

  @if (!arrivedAsStated) {
  <!-- Backorder: lo que venía en el delivery y no llegó -->
  <div class="backorder">
    <div class="backorder__title"><mat-icon>pending_actions</mat-icon> Insumos pendientes (backorder)
      <span>lo que no llegó en este delivery</span></div>
    <div class="add-row">
      <mat-form-field class="add-row__search">
        <mat-label>Buscar insumo pendiente</mat-label>
        <input matInput [(ngModel)]="backorderFilter">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    @if (backorderFilter.trim()) {
      <div class="results">
        @for (prod of filteredBackorder; track prod.id) {
          <button mat-menu-item (click)="addBackorder(prod)"><b>{{ prod.code }}</b>&nbsp;{{ prod.description }}</button>
        }
      </div>
    }
    @if (backorder.length) {
      <table class="rows">
        <tr><th>Código</th><th>Descripción</th><th class="num">Piezas pendientes</th><th></th></tr>
        @for (b of backorder; track b.product; let i = $index) {
          <tr>
            <td>{{ b.code }}</td><td>{{ b.description }}</td><td class="num">
              <span class="qty">
                <button type="button" class="qty__btn" (click)="step(b, -1)" [disabled]="b.quantity <= 1" aria-label="Una pieza menos">−</button>
                <input class="cell cell--num" type="number" min="1" step="1" [(ngModel)]="b.quantity" (blur)="fixQty(b)" (change)="fixQty(b)" aria-label="Piezas pendientes">
                <button type="button" class="qty__btn" (click)="step(b, 1)" aria-label="Una pieza más">+</button>
              </span>
            </td>
            <td><button mat-icon-button color="warn" (click)="removeBackorder(i)" aria-label="Quitar pendiente"><mat-icon>close</mat-icon></button></td>
          </tr>
        }
      </table>
      <p class="count"><b>{{ backorderPieces }}</b> pieza(s) pendientes</p>
    } @else {
      <p class="empty">Sin pendientes: todo llegó.</p>
    }
  </div>

  <!-- Extras: lo que llegó y no venía en el DLV -->
  <div class="backorder backorder--extra">
    <div class="backorder__title"><mat-icon>add_box</mat-icon> Insumos extras
      <span>lo que llegó y no venía en el DLV</span></div>
    <div class="add-row">
      <mat-form-field class="add-row__search">
        <mat-label>Buscar insumo extra</mat-label>
        <input matInput [(ngModel)]="extraFilter">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    @if (extraFilter.trim()) {
      <div class="results">
        @for (prod of filteredExtra; track prod.id) {
          <button mat-menu-item (click)="addExtra(prod)"><b>{{ prod.code }}</b>&nbsp;{{ prod.description }}</button>
        }
      </div>
    }
    @if (extra.length) {
      <table class="rows">
        <tr><th>Código</th><th>Descripción</th><th class="num">Piezas extra</th><th></th></tr>
        @for (b of extra; track b.product; let i = $index) {
          <tr>
            <td>{{ b.code }}</td><td>{{ b.description }}</td><td class="num">
              <span class="qty">
                <button type="button" class="qty__btn" (click)="step(b, -1)" [disabled]="b.quantity <= 1" aria-label="Una pieza menos">−</button>
                <input class="cell cell--num" type="number" min="1" step="1" [(ngModel)]="b.quantity" (blur)="fixQty(b)" (change)="fixQty(b)" aria-label="Piezas extra">
                <button type="button" class="qty__btn" (click)="step(b, 1)" aria-label="Una pieza más">+</button>
              </span>
            </td>
            <td><button mat-icon-button color="warn" (click)="removeExtra(i)" aria-label="Quitar extra"><mat-icon>close</mat-icon></button></td>
          </tr>
        }
      </table>
      <p class="count"><b>{{ extraPieces }}</b> pieza(s) extra</p>
    } @else {
      <p class="empty">Sin extras.</p>
    }
  </div>
  }

  <mat-form-field class="wide"><mat-label>Comentarios adicionales</mat-label>
    <input matInput [(ngModel)]="comments">
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)">Cancelar</button>
  <button mat-raised-button color="accent" (click)="save()"><mat-icon>move_to_inbox</mat-icon> Aceptar entrada</button>
</mat-dialog-actions>
